import { render, staticRenderFns } from "./OrderSources.vue?vue&type=template&id=77bfd557&"
import script from "./OrderSources.vue?vue&type=script&lang=js&"
export * from "./OrderSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports